import { styled, Paper, Box } from "@mui/material";

export const Container = styled(Paper)({
  position: "relative", // size overlay during resize
  background: "#FFFFFF",
  border: "1px solid #F3F3F3",
  boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.04)",
  borderRadius: 8,
});

export const Header = styled(Box)`
  border-bottom: 1;
  border-color: divider;
  display: flex;
  justify-content: space-between;
`;

export const InnerContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
}));
